module.exports = __webpack_public_path__ + "static/media/footer-shape2.7c95f327.png";